module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cardHeader1":"Ottawa County Online Services","cardHeader2":"Online Forms","cardHeader2-2":"Marriage Application, Notary and CPL","link1":"Tap to open","alter":"OR"},"es":{"cardHeader1":"Servicios en Línea","cardHeader2":"Formas","cardHeader2-2":"Marriage Application, Notary and CPL","link1":"Enlace abierto","alter":"O"}}')
  delete Component.options._Ctor
}
